<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="M13.1 3.7a6 6 0 0 1 6-.5q1.5.6 2.2 1.4 1.6 2 1.3 4.6a6 6 0 0 1-1.7 4.1l-7.9 8-.7.2-.7-.3-.3-.7q0-.5.3-.8l4.7-4.7q.4-.3 0-.7-.4-.5-.7 0L10.8 19l-.7.3-.7-.3-.3-.7q0-.4.3-.7l4.7-4.8q.5-.4 0-.8-.3-.3-.7 0l-4.8 4.8-.7.3-.7-.3-.4-.7q0-.4.4-.8l4.8-4.7q.3-.4 0-.8-.5-.3-.8 0l-4.8 4.8-.7.3-.7-.3-.3-.7q0-.5.3-.8l5.8-5.8 3.7 3.7q.6.5 1.5.5a2 2 0 0 0 1.7-.8q.4-.8.3-1.4 0-.8-.7-1.4zm2.2 6.5-4.5-4.4-7.3 7.3q-1.3-1.3-1.5-4t1.5-4.8a6 6 0 0 1 4.4-1.8q2.6 0 4.4 1.8l4.4 4.5q.3.3.3.7t-.3.7l-.7.3z"
    />
  </svg>
</template>
